import { Editor } from 'slate';
import { EDITOR_FOCUS, EDITOR_TO_INPUT_HANDLER } from 'src/layout-engine/utils/weak-maps';

export type ReactEditor = {
  __reactEditor: true;
};

/**
 * A React and DOM-specific version of the `Editor` interface.
 */
export const ReactEditor = {
  /**
   * Blur the editor.
   */
  blur(editor: Editor): void {
    const editorFocus = EDITOR_FOCUS.get(editor);
    const el = EDITOR_TO_INPUT_HANDLER.get(editor);

    editorFocus?.setFocused(false);
    if (window.document.activeElement === el) el.blur();
  },

  /**
   * Focus the editor.
   */
  focus(editor: Editor): void {
    const editorFocus = EDITOR_FOCUS.get(editor);
    const el = EDITOR_TO_INPUT_HANDLER.get(editor);

    // PERF: Typing calls focus after every input. Avoid dispatching focused state when unchanged.
    if (editorFocus && !editorFocus.isFocused) editorFocus.setFocused(true);
    if (el && window.document.activeElement !== el) el.focus({ preventScroll: true });
  },

  /**
   * Check if the editor is focused.
   */
  isFocused(editor: Editor): boolean {
    const editorFocus = EDITOR_FOCUS.get(editor);
    return !!editorFocus?.isFocused;
  },

  isReactEditor<T>(v: T): v is T & ReactEditor {
    return Editor.isEditor(v) && '__reactEditor' in v && v.__reactEditor === true;
  },
};
